(function fix() {
  var o = document.querySelector('.sf-th-v');
  if (o) o.remove();
  document.body.classList.remove('sf-tr');
  document.documentElement.style.setProperty('height', 'auto', 'important');
  document.documentElement.style.setProperty('overflow', 'visible', 'important');
  document.documentElement.style.setProperty('overflow-x', 'hidden', 'important');
  document.body.style.setProperty('height', 'auto', 'important');
  document.body.style.setProperty('overflow-y', 'visible', 'important');
  document.body.style.setProperty('overflow-x', 'hidden', 'important');
})();

document.addEventListener('DOMContentLoaded', function() {
  var o = document.querySelector('.sf-th-v');
  if (o) o.remove();
  document.body.classList.remove('sf-tr', 'no-scroll', 'overflow-hidden');
  document.documentElement.style.setProperty('height', 'auto', 'important');
  document.documentElement.style.setProperty('overflow-x', 'hidden', 'important');
  document.documentElement.style.setProperty('overflow-y', 'visible', 'important');
  document.body.style.setProperty('height', 'auto', 'important');
  document.body.style.setProperty('overflow-y', 'visible', 'important');
  document.body.style.setProperty('overflow-x', 'hidden', 'important');
});

window.addEventListener('load', function() {
  var o = document.querySelector('.sf-th-v');
  if (o) o.remove();
  document.body.classList.remove('sf-tr', 'no-scroll', 'overflow-hidden');
});

new MutationObserver(function(m) {
  m.forEach(function(r) {
    r.addedNodes.forEach(function(n) {
      if (n.nodeType === 1 && n.classList && n.classList.contains('sf-th-v')) {
        n.remove();
        document.documentElement.style.setProperty('height', 'auto', 'important');
        document.documentElement.style.setProperty('overflow-x', 'hidden', 'important');
        document.documentElement.style.setProperty('overflow-y', 'visible', 'important');
        document.body.style.setProperty('height', 'auto', 'important');
        document.body.style.setProperty('overflow-y', 'visible', 'important');
        document.body.classList.remove('sf-tr', 'no-scroll', 'overflow-hidden');
      }
    });
  });
}).observe(document.documentElement, { childList: true, subtree: true });
